// node_modules
import { FC } from "react";
// Components
import { ActionObjects } from "./ActionObjects/ActionObjects";
import { EnvironmentVariables } from "./EnvironmentVariables/EnvironmentVariables";
import { NewSpecificationUnits } from "./NewSpecificationUnits/NewSpecificationUnits";
// styles
import styles from "./savedQueryFields.module.scss";

type TSavedQueryFieldsProps = {
    isSpecificationUnitsEnabled: boolean
}

export const SavedQueryFields: FC<TSavedQueryFieldsProps> = ({isSpecificationUnitsEnabled}) => {
    return (
        <div className={styles.selectedQuerySearchTermsContainer}>
            <div className={styles.actionObjectAndSpecsContainer}>
                <ActionObjects />
                { isSpecificationUnitsEnabled ? <NewSpecificationUnits /> : null}
            </div>
            <div className={styles.keywordsContainer}>
                <EnvironmentVariables />
            </div>
        </div>
    );
};
